import { Col, Row } from "reactstrap";
import H5 from "../Headings/H5Element";
import ProductImageCard from "../ProductImageCard";

interface ImageCollectionProps {
  title: string;
  images: string[];
  handleDownload: (src: string) => void;
}

const ImageCollection = ({
  title,
  images,
  handleDownload,
}: ImageCollectionProps) => {
  if (!images || images.length === 0) return null;

  return (
    <Row className="mb-5">
      <H5 className="text-underline mb-3">{title}</H5>
      {images.map((src, index) => (
        <Col xs="12" md="4" key={index}>
          <ProductImageCard
            key={index}
            imageSrc={src}
            altImage="download"
            handleDownload={handleDownload}
            isShowHover={true}
          />
        </Col>
      ))}
    </Row>
  );
};

export default ImageCollection;
